import _ from 'lodash'
import country_info from './code.json'
import { Switch as cSwitch } from '@coreui/vue'
import 'flag-icon-css/css/flag-icon.css';
import Bell from 'vue-notification-bell'

// path, paramater 만 지원
export default {
  name: 'RuleCountry',
  props: ['origin', 'name', 'is_setup', 'example', 'origin_use_geoip', '_show_block_only', 'mmdb_version', 'db_update_available', '_show_toogle_button', 'mmdb_latest', 'hide_count'],
  components : { cSwitch, Bell },
  computed: {},
  watch: {
    origin() {
      // 기존 값이 변경시 해당 데이터 업데이트, 컴포넌트로 사용시 필요
      // this.load() // 뷰 순환 참조로 사용하지 못함
      this.country_code = []
      console.log('RuleCountry.vue', 'mounted');
      this.model = this.origin ?  this.origin : []
      if(this.model) { this.origin.forEach(x => this.country_code.push(x)) }
      if(this.model.length == this.country_info.length) { this.select_all = true }

      this.use_geoip = this.origin_use_geoip
      // 기존에 있을 경우 블록 처리
      this.country_info.forEach(x => x.is_block = _.indexOf(this.origin, x.Code) > -1);
    }
  },
  data: () => {
    return {
      explain_modal_mmdb : false,
      select_all : false,
      country : '',
      country_info,
      explain_modal_code :false,
      model : [],
      ex : '',
      country_code : [],
      show_block_only : false,
      use_geoip : false,
    }
  },
  methods: {
    db_update_available_latest() {
      if(!this.mmdb_version || this.mmdb_version.split('.').length < 2) { return false }

      let agent_data = this.mmdb_version.split('.')
      let agent_year = Number(agent_data[0].replace('v', ''))
      let agent_month = Number(agent_data[1])
      console.log(agent_year, agent_month, 'agent version', this.mmdb_latest)

      if(!this.mmdb_latest || this.mmdb_latest.split('.').length < 2) { return false }

      let deploy_data = this.mmdb_latest.split('.')
      let deploy_year = Number(deploy_data[0].replace('v', ''))
      let deploy_month = Number(deploy_data[1])
      console.log(deploy_year, deploy_month, 'deploy version')

      // return true
      // 개발 서버 이므로
      // 2021.11 버전 이거나 이상일 경우 mmdb 업데이트 가능
      if((agent_year == deploy_year && agent_month < deploy_month) || (deploy_year > agent_year)) {
        return true
      }

      // return false
    },
    update() {
      this.$parent.$emit('update_db', this.mmdb_version)
    },
    set_flag(x) { return `explain flag-icon flag-icon-${(x || '').toLowerCase()}` },
    change_use_geoip(val) {
      console.log('toggle', val, this.use_geoip)
      this.$parent.$emit('use_geoip', val) // 변경될 때마다 업데이트
    },
    save_show_status(val, x) {
      // console.log('RuleCountry', val, x);
      // console.log(window.localStorage.getItem('RuleCountry'), 'www', val)
      window.localStorage.setItem('RuleCountry', val);
    },
    is_show(x) {
      return !this.country || x['Name'].toLowerCase().indexOf(this.country.toLowerCase()) > -1
    },
    toggle_all(val) {
      console.log(val)
      this.country_code = val === false ? [] : _.map(this.country_info, x => x.Code)
      this.$parent.$emit('update', this.country_code) // 변경될 때마다 업데이트
      this.country_info.forEach(x => x.is_block = val);
    },
    onSelect(code, name) {
      this.country_code = this.country_code.indexOf(code) < 0 ? _.concat(this.country_code, code) : _.filter(this.country_code, x => x != code)
      this.$parent.$emit('update', this.country_code) // 변경될 때마다 업데이트
    },
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    load() {
      this.country_code = []
      console.log('RuleCountry.vue', 'mounted');
      this.model = this.origin ?  this.origin : []
      if(this.model) { this.origin.forEach(x => this.country_code.push(x)) }
      if(this.model.length == this.country_info.length) { this.select_all = true }

      this.use_geoip = this.origin_use_geoip
      if(this._show_block_only != undefined) {
        this.show_block_only = this._show_block_only
      }
      // 기존에 있을 경우 블록 처리
      this.country_info.forEach(x => x.is_block = _.indexOf(this.origin, x.Code) > -1);
    }
  },
  created: function() {   console.log('RuleCountry.vue', 'created'); },
  destroyed: function() { console.log('RuleCountry.vue', 'destroyed'); },
  mounted: function() { this.load() }
}
